import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchStartupContents } from "../../../graphQL/controller/startupContentsController";
import { isPremiumUser } from "../../../utils/premiumUtils";
import Loading from "../../../components/Loading";
import AddBooks from "./AddBooks";
import BookSelector from "./SearchBook";
import SearchOwnBooks from "./SearchOwnBook";

const BooksEntryRouter = ({ fallback = "selector" }) => {
  const dispatch = useDispatch();
  const { credObj } = useSelector((store) => store.auth);
  const { hasAttemptedFetch, isLoading, startupData } = useSelector(
    (store) => store.startupContents
  );

  useEffect(() => {
    if (credObj && !hasAttemptedFetch && !isLoading) {
      dispatch(fetchStartupContents());
    }
  }, [credObj, hasAttemptedFetch, isLoading, dispatch]);

  // Wait for startup data so we do not flash the legacy screen for premium users.
  if (credObj && (!hasAttemptedFetch || isLoading)) {
    return <Loading center />;
  }

  const showPremiumFlow = isPremiumUser(startupData?.userSubscription);

  if (fallback === "own") {
    return <SearchOwnBooks />;
  }

  if (showPremiumFlow) {
    return <AddBooks />;
  }

  return <BookSelector />;
};

export default BooksEntryRouter;